import { BCMSRecord, BCMSStateManagerCRUD, useBCMSContext } from "@bcm-dev/bcms-vite";
import TemplateDetailsPage, { getDefaultData } from 'components/pages/TemplateDetailsPage';
import Classes from "model";

export default function CaptureAddNewTypeModalPaymentSelected(props) {
  const context = useBCMSContext();
  BCMSRecord.globalControllerFor(Classes, context);

  const data = BCMSStateManagerCRUD.init(getDefaultData())
    .update(["template", "transactionType"], "payment")
    .submit();

  return (
    <TemplateDetailsPage data={data} />
  )
}
